






























import { UsuarioNovo, UsuariosService } from "@/services/usuarios.service";
import Confirm from "@/shared/components/confirm.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { required, tamCampo, validSlug } from "@/shared/validators";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import Formulario from "./components/Formulario.vue";

@Component({
  components: {
    Confirm,
    Formulario,
  },
})
export default class NovoUsuario extends mixins(GlobalMixin) {
  usuario: UsuarioNovo = {
    nome: "",
    slug: "",
    email: "",
    senha: "",
    ativo: true,
    roles: [],
  };

  loading = false;

  rules = {
    nome: [required()],
    slug: [required(), validSlug()],
    email: [required()],
    senha: [required()],
    roles: [required(), tamCampo(1, "Selecione pelo menos 1 role")],
  };

  criarUsuario() {
    const form = this.$refs.form as any;
    if (form.validate()) {
      this.startLoader();
      UsuariosService.Criar(this.usuario)
        .then(this.voltar)
        .finally(this.stopLoader);
    }
  }

  voltar() {
    this.$router.push({
      name: "usuarios",
    });
  }
}
